import React, { useState } from "react";

import ReportItemHeader from "../common/ReportItemHeader";
import ChartLegend from "../common/ChartLegend";
import DoughnutChart from "../common/DoughnutChart";

import lbl from "../../data/Labels.json";

const FinanceProfileChart = ({ data }) => {
  const chartData = [
    {
      label: lbl.Present,
      value: data?.present_count || 0,
      percent: data?.present_percentage || 0,
      color: "#48C29D",
    },
    {
      label: lbl.Absent,
      value: data?.absent_count || 0,
      percent: data?.absent_percentage || 0,
      color: "#9A3859",
    },
    {
      label: lbl.Substitute,
      value: data?.substitute_count || 0,
      percent: data?.substitute_percentage || 0,
      color: "#8CAA72",
    },
    {
      label: lbl.Holiday,
      value: data?.holiday_count || 0,
      percent: data?.holiday_percentage || 0,
      color: "#EF9C0E",
    },
  ];

  const [shrink, setShrink] = useState(false);
  return data ? (
    <div className={`report-container _25-per ${shrink && "shrink"}`}>
      <ReportItemHeader
        title={data?.entry_year}
        shrink={shrink}
        setShrink={setShrink}
      />
      <div className="sub-title">
        <p>{`${lbl.From} ${data?.start_date}`}</p>
        <p>{`${lbl.To} ${data?.end_date}`}</p>
      </div>
      <div className="chart">
        <DoughnutChart data={chartData} />
      </div>
      <div className="chart-legend">
        <ChartLegend data={chartData} />
      </div>
      <div className="report-order-list">
        <ol>
          <li>
            <b>{`$ ${data?.salary_per_hour}`}</b>
            <span>{lbl.SalaryPeHour}</span>
          </li>
          <li>
            <b>{`$ ${data?.total_benefit}`}</b>
            <span>{lbl.TotalBenefits}</span>
          </li>
          <li>
            <b>{`$ ${data?.salary_before_tax}`}</b>
            <span>{lbl.SalaryBeforeTax}</span>
          </li>
          <li>
            <b>{`$ ${data?.salary_tax}`}</b>
            <span>{lbl.Tax}</span>
          </li>
          <li>
            <b>{`$ ${data?.payable}`}</b>
            <span>{lbl.Payable}</span>
          </li>
          <li>
            <b>{`$ ${data?.paid}`}</b>
            <span>{lbl.Paid}</span>
          </li>
          <li>
            <b>{`$ ${data?.half_year_balance}`}</b>
            <span>{lbl.Balance}</span>
          </li>
        </ol>
      </div>
    </div>
  ) : null;
};

export default FinanceProfileChart;
